import { Modal } from 'react-bootstrap';
import { RiCheckboxCircleFill } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import './Copied.styles.css';

function Copied({ show, onHide }) {
    const { t } = useTranslation();

    return (
        <Modal
            size="sm"
            show={show}
            onHide={onHide}
            centered
            className="copied-modal"
            backdrop={false}
        >
            <Modal.Body className="copied-modal-body gap-2">
                <RiCheckboxCircleFill color="white" />
                <span className="notification-text">{t('buttons.copied')}</span>
            </Modal.Body>
        </Modal>
    );
}

export default Copied;
